import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

function SidenavCollapse({
  icon,
  name,
  active,
  noCollapse,
  nested = false,
  isOpen = false,
  hasSubitems = false,
  onClick,
  ...rest
}) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;

  return (
    <ListItem
      component="li"
      sx={{
        pl: nested ? 3 : 1,
        cursor: "pointer",
        mb: 0.5,
      }}
      onClick={onClick}
    >
      <MDBox
        {...rest}
        sx={(theme) => ({
          ...collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            darkMode,
            sidenavColor,
          }),
          backgroundColor: active
            ? darkMode
              ? "rgba(255, 255, 255, 0.2)"
              : "rgba(0, 0, 0, 0.08)"
            : "transparent",
          "&:hover": {
            backgroundColor: active
              ? darkMode
                ? "rgba(255, 255, 255, 0.25)"
                : "rgba(0, 0, 0, 0.12)"
              : darkMode
              ? "rgba(255, 255, 255, 0.1)"
              : "rgba(0, 0, 0, 0.04)",
          },
          transition: "background-color 0.2s ease",
        })}
      >
        <ListItemIcon
          sx={(theme) =>
            collapseIconBox(theme, {
              transparentSidenav,
              whiteSidenav,
              darkMode,
              active,
            })
          }
        >
          {typeof icon === "string" ? (
            <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
          ) : (
            icon
          )}
        </ListItemIcon>

        {!miniSidenav && (
          <>
            <ListItemText
              primary={name}
              sx={(theme) => ({
                ...collapseText(theme, {
                  miniSidenav,
                  transparentSidenav,
                  whiteSidenav,
                  active,
                }),
                fontWeight: active ? "bold" : "regular",
              })}
            />
            {hasSubitems && (isOpen ? <ExpandLess /> : <ExpandMore />)}
          </>
        )}
      </MDBox>
    </ListItem>
  );
}

SidenavCollapse.defaultProps = {
  active: false,
  noCollapse: false,
  nested: false,
  isOpen: false,
  hasSubitems: false,
  onClick: () => {},
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  nested: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasSubitems: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SidenavCollapse;
